<template>
  <Wrapper
    :variant="['default', 'rounded']"
    :header="$t('_web_account-remove', 'Remove account')"
    class="remove-wrapper"
  >
    <TextBlock class="mb-5" tag="p">
      {{
        $t(
          '_web_account-remove-description-general',
          'Your account will be removed entirely from the system. You will need to complete user verification.'
        )
      }}
    </TextBlock>
    <Btn
      class="btn-primary"
      :label="$t('_web_account-remove', 'Remove account')"
      @click.prevent.stop="openRemoveAccountModal"
    />
  </Wrapper>
</template>

<script>
import { mapActions } from 'vuex';
import Wrapper from '../../PanelWrapper';
import TextBlock from '@/components/atoms/TextBlock';
import Btn from '@/components/atoms/HeraFormBtn';

export default {
  name: 'RemoveAccount',
  components: { Wrapper, TextBlock, Btn },
  props: {},
  data() {
    return {};
  },
  methods: {
    ...mapActions(['openModal']),
    openRemoveAccountModal() {
      this.openModal({
        name: 'RemoveAccountModal',
        settings: {
          containerClass: 'p-0 overflow-hidden',
          variant: 'fit-content',
          closeIcon: true,
          clickOnBackdrop: true,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.remove-wrapper h4 {
  margin-bottom: 0 !important;
}
</style>
